/**
 * @flow
 * @relayHash 419bacee24a71d1b9356ca0bf2c228ad
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CopyUserLineItemsToEstimateInput = {
  clientMutationId?: ?string,
  estimate_id: string,
  user_line_item_ids: $ReadOnlyArray<?string>,
};
export type Library_Estimate_copyUserLineItemsToEstimateMutationVariables = {|
  input: CopyUserLineItemsToEstimateInput
|};
export type Library_Estimate_copyUserLineItemsToEstimateMutationResponse = {|
  +copyUserLineItemsToEstimate: ?{|
    +estimate: ?{|
      +estimate_line_items: ?{|
        +edges: ?$ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +title: ?string,
            +description: ?string,
            +position: ?number,
            +price_cents: ?number,
            +price_currency: ?string,
            +quantity: ?number,
          |}
        |}>
      |}
    |}
  |}
|};
export type Library_Estimate_copyUserLineItemsToEstimateMutation = {|
  variables: Library_Estimate_copyUserLineItemsToEstimateMutationVariables,
  response: Library_Estimate_copyUserLineItemsToEstimateMutationResponse,
|};
*/


/*
mutation Library_Estimate_copyUserLineItemsToEstimateMutation(
  $input: CopyUserLineItemsToEstimateInput!
) {
  copyUserLineItemsToEstimate(input: $input) {
    estimate {
      estimate_line_items {
        edges {
          node {
            id
            title
            description
            position
            price_cents
            price_currency
            quantity
          }
        }
      }
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CopyUserLineItemsToEstimateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "CopyUserLineItemsToEstimateInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "estimate_line_items",
  "storageKey": null,
  "args": null,
  "concreteType": "EstimateLineItemConnection",
  "plural": false,
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "EstimateLineItemEdge",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": "EstimateLineItem",
          "plural": false,
          "selections": [
            v2,
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "title",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "description",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "position",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_cents",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "price_currency",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "quantity",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
  "id": null,
  "text": "mutation Library_Estimate_copyUserLineItemsToEstimateMutation(\n  $input: CopyUserLineItemsToEstimateInput!\n) {\n  copyUserLineItemsToEstimate(input: $input) {\n    estimate {\n      estimate_line_items {\n        edges {\n          node {\n            id\n            title\n            description\n            position\n            price_cents\n            price_currency\n            quantity\n          }\n        }\n      }\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToEstimatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              v3
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "Library_Estimate_copyUserLineItemsToEstimateMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "copyUserLineItemsToEstimate",
        "storageKey": null,
        "args": v1,
        "concreteType": "CopyUserLineItemsToEstimatePayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "estimate",
            "storageKey": null,
            "args": null,
            "concreteType": "Estimate",
            "plural": false,
            "selections": [
              v3,
              v2
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '35319167e802e3260f305f21fd500c52';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/__generated__/Library_Estimate_copyUserLineItemsToEstimateMutation.graphql.js